// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.connect.campaign.ConnectCampaignListResponse */
/* istanbul ignore next */
@GandalfModel
export class ConnectCampaignListResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	connectCampaignId!: number | null;

	@GandalfProperty({ designType: Date })
	createdOn!: Date | null;

	@GandalfProperty({ designType: Number })
	ineligibleCount!: number | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfProperty({ designType: Number })
	openedCount!: number | null;

	@GandalfProperty({ designType: Number })
	optedOutCount!: number | null;

	@GandalfProperty({ designType: String })
	queryName!: string | null;

	@GandalfProperty({ designType: Date })
	scheduledDate!: Date | null;

	@GandalfConstantDecorator(constants.ConnectCampaignStatus)
	@GandalfProperty({ designType: constants.ConnectCampaignStatus })
	status!: constants.ConnectCampaignStatus | null;

	@GandalfProperty({ designType: String })
	subject!: string | null;

	@GandalfProperty({ designType: Number })
	totalCount!: number | null;

	@GandalfProperty({ designType: Number })
	undeliveredCount!: number | null;

}
